module.exports = __webpack_public_path__ + "media/images/application2/Publisher__header__info__a-ae5ff784f512f57f1fbb5eec3a42ff0b.svg";